import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import {
  RESET_INTERNAL,
  RESET_ACTIVE,
  UPDATE_INTERNAL,
  UPDATE_ACTIVE,
  UPDATE_PAGE,
  RESET_PAGE,
  UPDATE_FILE_TYPE,
  RESET_FILE_TYPE,
  FILE_TYPE,
  PAGE,
} from './constants'

const resetActive = () => false
const resetInternal = () => false
const resetPage = () => PAGE.TYPE_SELECTION
const resetFileType = () => FILE_TYPE.SCHEMATIC.value
const updateFileType = (prev, { value }) => value
const updatePage = (prev, { page }) => page
const updateActive = (prev, { active }) => active
const updateInternal = (prev, { value }) => value

const activeReducer = createReducer(false, {
  [RESET_ACTIVE]: resetActive,
  [UPDATE_ACTIVE]: updateActive
})

const pageReducer = createReducer(resetPage(), {
  [RESET_PAGE]: resetPage,
  [UPDATE_PAGE]: updatePage
})

const fileTypeReducer = createReducer(resetFileType(), {
  [RESET_FILE_TYPE]: resetFileType,
  [UPDATE_FILE_TYPE]: updateFileType
})

const internalReducer = createReducer(resetInternal(), {
  [RESET_INTERNAL]: resetInternal,
  [UPDATE_INTERNAL]: updateInternal
})

export default combineReducers({
  active: activeReducer,
  page: pageReducer,
  fileType: fileTypeReducer,
  internal: internalReducer
})
